import React, { FC, useMemo, useState, useRef } from "react";
import { RouterParamType } from "@/model/navModel";
import { YhBox } from "@/components/YhBox";
import { Table, Modal, message, Button, Image } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useExternalBillDetailsModel } from "./externalBillModelDetails";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";
import { QRCodeSVG } from 'qrcode.react';
import html2canvas from "html2canvas";
import logo from "../../../../../assets/images/logo1.png"; // 替换为实际logo路径
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { getQrcodeUrl } from "@/utils/constants";
import { QuoteHistoryModal } from "./QuoteHistoryModal";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { detailLookList, detailLookForm } = useExternalBillDetailsModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const [historyVisible, setHistoryVisible] = useState(false);
    const [currentQuoteId, setCurrentQuoteId] = useState('');
    // 二维码相关状态
    const [qrcodeVisible, setQrcodeVisible] = useState(false);
    const [qrcodeUrl, setQrcodeUrl] = useState("");
    const [currentRecord, setCurrentRecord] = useState<any>(null);
    const qrRef = useRef<HTMLDivElement>(null);


    // 生成修改报价的二维码链接
    const generateQrUrl = (record: any) => {
        // 根据实际环境和业务规则生成URL
        const baseUrl = getQrcodeUrl()
        return `${baseUrl}/send.html?order=${detailLookForm.id}& quoteId=${record.id}`;
    };

    // 保存二维码图片
    const handleSaveQRCode = async () => {
        if (!qrRef.current) return;

        try {
            const canvas = await html2canvas(qrRef.current, {
                scale: 2,
                useCORS: true
            });
            const imgData = canvas.toDataURL("image/png");
            const a = document.createElement("a");
            a.href = imgData;
            a.download = `修改报价二维码_${currentRecord?.id || Date.now()}.png`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            message.success("二维码保存成功");
        } catch (error) {
            console.error("保存二维码失败", error);
            message.error("保存二维码失败，请重试");
        }
    };

    const columns: any = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '单位名称',
            width: 120,
            dataIndex: 'supplierName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '是否拖车',
            width: 160,
            dataIndex: 'isTransport',
            render: (text: any, res: any) => <span>{res.isTransport === 0 ? "是" : "否"}</span>,
        }, {
            title: '路线',
            width: 160,
            dataIndex: 'route',
        }, {
            title: '工时费用',
            width: 160,
            dataIndex: 'itemAmount',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '维修内容',
            width: 160,
            dataIndex: 'itemNote',
        }, {
            title: '配件费用',
            width: 160,
            dataIndex: 'materialAmount',
        }, {
            title: '更换配件',
            width: 160,
            dataIndex: 'materialNote',
        }, {
            title: '是否选用',
            width: 100,
            dataIndex: 'checked',
            align: "center",
            render: (text: any, res: any) => (
                <div style={{
                    width: '100%',
                    height: '100%',
                    fontWeight: 'bolder',
                    padding: '0px 10px',
                    backgroundColor: res.checked == 1 ? "#66e166" : "white"
                }}>
                    {res.checked === 1 ? "是" : "否"}
                </div>
            ),
        },
        {
            title: '操作',
            width: 80,
            fixed: "right",
            render: (text: any, record: any) => {
                return (
                    <YhAuth resCode={ResourceAuthEnum.VRM2_EXTERNALREPAIR_HISTORYPRICE}>
                        <button
                            style={{
                                backgroundColor: "#faad1417",
                                color: "#faad14",
                                border: "1px solid #faad14",
                                borderRadius: "2px",
                                padding: "4px 8px",
                                cursor: "pointer",
                                fontSize: "12px",
                                transition: "all 0.2s",
                            }}
                            onClick={() => {
                                setCurrentQuoteId(record.supplierName);
                                setHistoryVisible(true);
                            }}
                        >
                            报价历史
                        </button>
                    </YhAuth>
                );
            }
        },
        // ...((str) => {
        //     if (str) {
        //         return [
        //             {
        //                 title: '操作',
        //                 width: 111,
        //                 fixed: "right",
        //                 render: (text: any, record: any) => {
        //                     return (
        //                         <YhAuth resCode={ResourceAuthEnum.VRM2_EXTERNALREPAIR_EDITPRICE}>
        //                             <button
        //                                 style={{
        //                                     backgroundColor: "#faad1417",
        //                                     color: "#faad14",
        //                                     border: "1px solid #faad14",
        //                                     borderRadius: "2px",
        //                                     padding: "4px 8px",
        //                                     cursor: "pointer",
        //                                     fontSize: "12px",
        //                                     transition: "all 0.2s",
        //                                 }}
        //                                 onClick={() => {
        //                                     setCurrentRecord(record);
        //                                     setQrcodeUrl(generateQrUrl(record));
        //                                     setQrcodeVisible(true);
        //                                 }}
        //                             >
        //                                 修改报价信息
        //                             </button>
        //                         </YhAuth>
        //                     );
        //                 }
        //             },
        //         ]
        //     } else {
        //         return []
        //     }
        // })(detailLookForm.status == 'external_repair.send'),
    ];

    const roleColumns = useMemo(() => {
        const params = { "code": "stockOut", "roleCodes": roles };
        return getRoleColumns("stockOut", "明细", columns, params);
    }, [roles, detailLookList]);

    return (
        <>
            <YhBox title="维修厂信息" >
                <Table
                    bordered
                    columns={roleColumns}
                    dataSource={detailLookList}
                    pagination={false}
                    scroll={{ x: 'max-content', y: 400 }}
                />
            </YhBox>

            {/* 二维码模态框 */}
            <Modal
                title="修改报价二维码"
                open={qrcodeVisible}
                onCancel={() => setQrcodeVisible(false)}
                footer={[
                    <Button
                        key="save"
                        type="primary"
                        onClick={handleSaveQRCode}
                    >
                        保存图片
                    </Button>,
                    <Button
                        key="cancel"
                        onClick={() => setQrcodeVisible(false)}
                    >
                        关闭
                    </Button>
                ]}
                width={400}
                centered
            >
                <div ref={qrRef} style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "20px 0"
                }}>
                    <div style={{ position: "relative" }}>
                        <QRCodeSVG
                            value={qrcodeUrl}
                            size={200}
                            fgColor="#076d4f"
                        // bgColor='#000'
                        />
                        {/* 中间logo */}
                        <div style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            backgroundColor: "white",
                            borderRadius: "4px",
                            padding: "8px",
                            width: 50,
                            height: 50,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}>
                            <Image
                                src={logo}
                                style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                alt="logo"
                            />
                        </div>
                    </div>
                </div>
                <div style={{ textAlign: "center", color: "#666", fontSize: "14px" }}>
                    扫描二维码修改报价信息
                </div>
            </Modal>
            <QuoteHistoryModal
                visible={historyVisible}
                onCancel={() => setHistoryVisible(false)}
                orderCode={(detailLookForm.code as string)}
                quoteId={currentQuoteId}
            />
        </>
    );
};